//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import lineCharts from '~/components/envDetail/lineCharts' // 折线图
import spotCharts from '~/components/envDetail/spotCharts' // 交易滑点走势
import breakpointCharts from '~/components/envDetail/breakpointCharts' // 断线情况
import breadCrumbs from '~/components/common/breadCrumbs.vue'
export default {
  components: {
    lineCharts, spotCharts, breakpointCharts, 'bread-crumbs': breadCrumbs
  },
  async asyncData ({ $api, store, $cookies, route, redirect }) {
    const { locale = 'en' } = store.state
    let { broker = '' } = route.params
    const cookieBroker = JSON.parse($cookies.get('rankObj') || '{}')
    console.log(cookieBroker)
    broker = broker?.split('.')[0] || ''
    if (!broker) return redirect(`/${locale}/data/EnvRanking.html`)
    try {
      const detailData = await $api.burstData.newDetailService({ traderid: broker, period: 2, vps_area: cookieBroker?.areaType || 1, account_type: cookieBroker?.account_type || 1 })
      return {
        brokerId: broker,
        detailData
      }
    } catch (error) {}
  },
  data () {
    return {
      brokerId: '' // 交易商id
    }
  },
  head () {
    const { ename = '', cname = '', Grade = '' } = this?.detailData
    const title = this.$t('19810')?.replace('{0}', ename)?.replace('{1}', cname)?.replace('{3}', Grade)
    const description = this.$t('19811')?.replace('{0}', ename)?.replace('{1}', cname)?.replace('{3}', Grade)
    return {
      title,
      meta: [
        { name: 'Keywords', content: this.$t('TYY_000667') },
        { name: 'Description', content: description }
      ]
    }
  },
  methods: {
    showText (text) {
      if (text == 'Perfect' || text == 'Poor') return true
      else return false
    },
    // 16进制颜色转换rgba
    olorRgb (color, type = 0) {
      if (!color) return false
      const reg = /^#([0-9a-fA-f]{3}|[0-9a-fA-f]{6})$/
      let sColor = color.toLowerCase()
      if (sColor && reg.test(sColor)) {
        if (sColor.length === 4) {
          let sColorNew = '#'
          for (let i = 1; i < 4; i += 1) {
            sColorNew += sColor.slice(i, i + 1).concat(sColor.slice(i, i + 1))
          }
          sColor = sColorNew
        }
        // 处理六位的颜色值
        const sColorChange = []
        for (let i = 1; i < 7; i += 2) {
          sColorChange.push(parseInt('0x' + sColor.slice(i, i + 2)))
        }
        if (type == 0) return 'rgba(' + sColorChange.join(',') + ')'
        else if (type == 1) return 'rgba(' + sColorChange.join(',') + ',.2' + ')'
        else if (type == 2) return 'rgba(' + sColorChange.join(',') + ',.1' + ')'
      } else {
        return sColor
      }
    },
    // 获取颜色
    getColor (text) {
      if (!text) return false
      return [this.olorRgb(this.detailData?.color[text], 0), this.olorRgb(this.detailData?.color[text], 1), this.olorRgb(this.detailData?.color[text], 2)]
    },
    // 跳转
    skip (num = 0) {
      if (num == 3 && !this.filterSpecial()) window?.open(`${this.$store.getters.breadHome}dealer/${this.brokerId}.html`)
    }
  }
}
